export class LoyaltyUser {
    constructor(props) {
        this.sessionId = props && props.sessionId;
        this.name = props && props.name;
        this.surname = props && props.surname;
        this.email = props && props.email;
        this.city = props && props.city;
        this.countryCode = props && props.countryCode;
        this.phone = props && props.phone;
        this.address = props && props.address;
        this.idDocument = props && props.idDocument;
        this.receiveOffers = props && props.receiveOffers;
        this.birthDate = props && props.birthDate;
    }
    static of(props) {
        return new LoyaltyUser(props);
    }
    isValid() {
        return !!this.sessionId;
    }
}
